interface AuthAlertProps {
  children: React.ReactNode;
  title?: string;
  style?: React.CSSProperties;
}

export function AuthAlert({ title, children, style }: AuthAlertProps) {
  return (
    <div className="auth-alert" role="alert" style={style}>
      <div className="auth-alert-icon">!</div>
      <div className="auth-alert-body">
        {title && <div className="auth-alert-title">{title}</div>}
        <div className="auth-alert-msg">{children}</div>
      </div>
    </div>
  );
}
